import { useMemo } from "react";
import { Contact } from "../../interfaces/DTO/crm/contact";
import { FamilyMembershipType } from "../../interfaces/DTO/crm/family";
import { useContacts } from "./useContacts";
import { useFamilyMembersByFamily } from "./useFamilyMembers";

/** the client's spouse - the family's other contributing member (undefined - no family / no such member) */
export const useContactSpouse = (contactId: number | undefined, familyId: number | undefined): Contact | undefined => {
  const { data: members = [] } = useFamilyMembersByFamily(familyId ?? 0, !!familyId);
  const { data: contacts = [] } = useContacts();
  return useMemo(() => {
    const spouseMember = members.find(
      (m) => m.contact_id !== contactId && m.family_membership_type === FamilyMembershipType.Contributor
    );
    return spouseMember ? contacts.find((c) => c.id === spouseMember.contact_id) : undefined;
  }, [members, contacts, contactId]);
};
